module.exports = __webpack_public_path__ + "static/media/product_17.edbb7003.jpg";